import { render, staticRenderFns } from "./PazienteTeleconsultoListComponent.vue?vue&type=template&id=6e3a8d7e"
import script from "./PazienteTeleconsultoListComponent.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports